import { ProductType } from '@hc-frontend/core-types';

export function getCriteoAccount(product: ProductType): number | null {
  if (product === ProductType.Enum.HEALTH) {
    return 24273;
  } else if (
    product === ProductType.Enum.MEDICARE ||
    product === ProductType.Enum.MEDICARE_ADVANTAGE
  ) {
    return 127863;
  } else return null;
}
